import React from "react";
import { Box, HStack, Skeleton, useColorModeValue } from "@chakra-ui/react";

export default function LeaderboardSkeleton() {
  const headerBg = useColorModeValue("gray.200", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const shimmerStart = useColorModeValue("gray.100", "gray.700");
  const shimmerEnd = useColorModeValue("blue.50", "gray.600");
  const skeletonProps = { startColor: shimmerStart, endColor: shimmerEnd, speed: 1.2 };

  return (
    <>
      {/* Stat filter row */}
      <HStack spacing={2} flexWrap="wrap">
        {[80, 70, 55, 90, 65, 65].map((w, i) => (
          <Skeleton key={i} height="32px" width={`${w}px`} borderRadius="full" {...skeletonProps} />
        ))}
      </HStack>

      {/* Time filter row */}
      <HStack spacing={2} flexWrap="wrap">
        {[65, 40, 60, 55, 45, 50].map((w, i) => (
          <Skeleton key={i} height="32px" width={`${w}px`} borderRadius="full" {...skeletonProps} />
        ))}
      </HStack>

      {/* Pagination bar */}
      <HStack spacing={3} justifyContent="flex-end">
        <Skeleton height="24px" width="90px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="24px" width="120px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Table */}
      <Box borderWidth="1px" borderColor={borderColor} rounded="lg" overflow="hidden">
        <HStack bg={headerBg} px={3} py={2} spacing={4}>
          <Skeleton height="12px" width="60px" flexShrink={0} {...skeletonProps} />
          <Skeleton height="12px" width="120px" flexShrink={0} {...skeletonProps} />
          <Skeleton height="12px" width="80px" flexShrink={0} {...skeletonProps} />
        </HStack>
        {Array.from({ length: 8 }).map((_, row) => (
          <HStack key={row} px={3} py={3} spacing={4} borderTopWidth="1px" borderColor={borderColor}>
            <Skeleton height="12px" width="30px" flexShrink={0} {...skeletonProps} />
            <Skeleton height="12px" width={`${100 + Math.floor(Math.random() * 40)}px`} flexShrink={0} {...skeletonProps} />
            <Skeleton height="12px" width={`${50 + Math.floor(Math.random() * 30)}px`} flexShrink={0} {...skeletonProps} />
          </HStack>
        ))}
      </Box>
    </>
  );
}
